import { useState, useEffect } from 'react'
import throttle from 'lodash/throttle'

const MAX_RETRIES = 5

export const useMoveChatbotButton = () => {
  const [moveChatbotButton, setMoveChatbotButton] = useState(true)
  const [stickyHeight, setStickyHeight] = useState<number>(0)

  const setVisibilityAndPosition = (retries = 0) => {
    // Only search for stickies placed at the bottom
    const stickyElement =
      // custom next/components Sticky case
      document.querySelector('#next-sticky-container.bottom') ||
      document.querySelector('#next-sticky-container.bottomPromos') ||
      // design system Sticky case
      document.querySelector('.mc-sticky--bottom')

    if (stickyElement) {
      const rect = stickyElement?.getBoundingClientRect()

      const isStickyVisible =
        rect.bottom <= window.innerHeight || rect.top < window.innerHeight

      // Workaround for promo sticky, animation makes it so when the scroll is finished and this function gets executed, the sticky is still
      // showing since it's in the animation process. Make sure we give enough time for animation to complete
      if (retries < MAX_RETRIES) {
        setTimeout(() => {
          setVisibilityAndPosition(retries + 1)
        }, 150)
      }
      setMoveChatbotButton(isStickyVisible)
      setStickyHeight(rect.height)
    } else {
      setMoveChatbotButton(false)
      setStickyHeight(0)
    }
  }

  const determinePosition = throttle(() => {
    setVisibilityAndPosition()
  }, 50)

  useEffect(() => {
    window.addEventListener('scroll', determinePosition)
    window.addEventListener('resize', determinePosition)

    return () => {
      window.removeEventListener('scroll', determinePosition)
      window.removeEventListener('resize', determinePosition)
    }
  }, [determinePosition])

  useEffect(() => {
    determinePosition()
  }, [determinePosition])

  return { moveChatbotButton, offset: stickyHeight }
}
